import React from 'react';

export const Story = [
	{
		id: 4,
		type: 'multicolumn',
		paragraphs: [
			{
				id: 41,
				paragraph: [
					<p>
						The idea of MoneyMap was conceived in the summer of 2015 by three
						school friends - Mohit Gang, Anil Bang, & Puneet Mehta. All three
						were working in different companies, yet put their heads together,
						combined their passion for investments and markets, and eventually
						partnered together. To build a paperless platform, they signed the
						papers [pun intended, formed the financial
					</p>,
				],
			},
			{
				id: 42,
				paragraph: [
					<p>
						consulting company, began defining the various financial advisory
						services, and coded the product over unlimited cups of coffee. After
						registering with SEBI as good law-abiding citizens, they acquired
						their first customer in September, 2016 (cheers). Since then, they
						have served XXXX investors and are managing an AUM of xxxx.
					</p>,
				],
			},
		],
	},
];
